import type { Location, SelectedProduct } from '../../types/sales.types';

export function getProductSourceLocationId(product: SelectedProduct): number | undefined {
  return product.warehouseInventoryProduct.location?.id;
}

export function isRemoteCartItem(
  product: SelectedProduct,
  sellingLocationId: number | undefined,
): boolean {
  if (sellingLocationId == null) return false;
  const sourceId = getProductSourceLocationId(product);
  return sourceId != null && sourceId !== sellingLocationId;
}

export function cartHasRemoteItems(
  products: SelectedProduct[],
  sellingLocationId: number | undefined,
): boolean {
  return products.some((p) => isRemoteCartItem(p, sellingLocationId));
}

/** Distinct remote source locations (branches or warehouse) → one auto SOL per source (v1). */
export function countRemoteFulfillmentGroups(
  products: SelectedProduct[],
  sellingLocationId: number | undefined,
): number {
  if (sellingLocationId == null) return 0;
  const ids = new Set<number>();
  for (const product of products) {
    const sourceId = getProductSourceLocationId(product);
    if (sourceId != null && sourceId !== sellingLocationId) {
      ids.add(sourceId);
    }
  }
  return ids.size;
}

export function getRemoteSourceLocations(
  products: SelectedProduct[],
  sellingLocationId: number | undefined,
): Location[] {
  if (sellingLocationId == null) return [];
  const byId = new Map<number, Location>();
  for (const product of products) {
    const loc = product.warehouseInventoryProduct.location;
    if (loc?.id != null && loc.id !== sellingLocationId) {
      byId.set(loc.id, loc);
    }
  }
  return Array.from(byId.values());
}
